import { render, staticRenderFns } from "./MyDesignsV3.vue?vue&type=template&id=cc6f0c06&scoped=true"
import script from "./MyDesignsV3.vue?vue&type=script&lang=js"
export * from "./MyDesignsV3.vue?vue&type=script&lang=js"
import style0 from "./MyDesignsV3.vue?vue&type=style&index=0&id=cc6f0c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6f0c06",
  null
  
)

export default component.exports